import React from 'react';

import CemeteryLogo from '../cemetery-logo/cemetery-logo';
import UserModuleContainer from '../user-module-container/user-module-container';

import useVhValue from '../../hooks/useVhValue';
import { LogoLocation } from '../../constants';

import './main-page.scss';

const MainPage = () => {
  useVhValue();

  return (
    <>
      <picture>
        <source srcSet="/main-bg/bg-desktop.jpg" media="(min-width: 1280px)" />
        <source srcSet="/main-bg/bg-tablet.jpg" media="(min-width: 768px)" />
        <img className="main-page__main-bg" alt="Cemetery landscape" />
      </picture>
      <div className="main-page__content">
        <CemeteryLogo location={LogoLocation.BACKGROUND} />
        <div className="main-page__user-module">
          <UserModuleContainer />
        </div>
      </div>
    </>
  );
};

export default MainPage;
